export default class {
	eventHandlers = {};

	on(eventName, handler) {
		if (!this.eventHandlers[eventName]) {
			this.eventHandlers[eventName] = [];
		}
		this.eventHandlers[eventName].push(handler);
	}

	emit(event) {
		this.eventHandlers[event].forEach((item) => {
			item.call(this, event);
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/event-emitter.js